import { Card, CardContent } from "@/components/ui/card";
import { Logo } from "@/components/app/Logo";

/**
 * Branded full-width hero used at the top of major sections to reinforce the
 * brand and give every page a consistent visual anchor.
 *
 * Variant defaults to "navy" (filled navy card with cream text). Pass
 * `variant="light"` for an inverted look (cream card with navy text + logo).
 */
export function BrandHero({
  overline,
  title,
  description,
  action = null,
  variant = "light",
  logoSize = 112,
  testid = "brand-hero",
}) {
  const navy = variant === "navy";
  return (
    <Card
      className={`shadow-none rounded-lg overflow-hidden ${
        navy
          ? "border-border bg-primary text-primary-foreground"
          : "border-2 border-primary bg-card"
      }`}
      data-testid={testid}
    >
      <CardContent className="p-8 sm:p-10 flex items-center gap-5 flex-wrap">
        <Logo size={logoSize} variant="mark" showText={false} className="shrink-0" />
        <div className="flex-1 min-w-[220px]">
          {overline ? (
            <p className={`text-xs uppercase tracking-[0.22em] ${navy ? "opacity-70" : "text-muted-foreground"}`}>
              {overline}
            </p>
          ) : null}
          <h1 className={`font-display text-3xl sm:text-4xl font-extrabold tracking-tighter mt-1 ${navy ? "" : "text-primary"}`}>
            {title}
          </h1>
          {description ? (
            <p className={`text-sm mt-2 max-w-prose ${navy ? "opacity-85" : "text-muted-foreground"}`}>
              {description}
            </p>
          ) : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </CardContent>
    </Card>
  );
}

export default BrandHero;
